import { Chip, PropTypes, TextField } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import { InputAdormentStyles } from 'assets/jss/mui-extras/inputAdormentStyle';
import * as React from 'react';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    inputValue: string;
    selectedItems?: Array<string>;
}

interface IProps {
    id: string;
    container?: any;
    label?: string;
    emptySelectionLabel?: string;
    placeHolder?: string;
    autoFocus?: boolean;
    multiple?: boolean;
    readonly?: boolean;
    margin?: 'dense' | 'normal' | 'none';
    error?: boolean;
    inputRef?: any;
    selectedItems?: string[];
    onUpdateSelection: (items: string[]) => void;
    onSelectedItemClick?: (item: string) => void;
    onResolveAvatar?: (item: string) => JSX.Element;
};

type Props = IProps & WithStyles<typeof InputAdormentStyles>;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class MuiTextInputToken extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            inputValue: '',
            selectedItems: this.getInitialSelectedItems(props)
        };
    }

    static defaultProps = {
        autoFocus: false,
        multiple: true,
    }

    private getInitialSelectedItems(props: IProps) {
        return props.selectedItems || [];
    }

    private handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const { inputValue, selectedItems } = this.state;

        if (this.props.readonly)
            event.preventDefault();
        else if (event.keyCode === 13) {

            if (selectedItems.indexOf(inputValue) === -1) {
                let selectedItems = this.state.selectedItems.slice(0);

                if (this.props.multiple)
                    selectedItems.push(inputValue);
                else
                    selectedItems = [inputValue];

                this.setState({
                    selectedItems,
                    inputValue: ""
                });

                this.props.onUpdateSelection(selectedItems);
            }
        }
    }

    private handleInputChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const v = (event.target as HTMLInputElement).value;
        this.setState({ inputValue: v });
    }

    private handleDelete = (item: string) => {
        const selectedItems = [...this.state.selectedItems];
        selectedItems.splice(selectedItems.indexOf(item), 1);

        this.setState({ selectedItems });
        this.props.onUpdateSelection(selectedItems);
    };

    public UNSAFE_componentWillReceiveProps(newProps: IProps) {
        if (newProps.selectedItems != this.props.selectedItems)
            this.setState({ selectedItems: this.getInitialSelectedItems(newProps) });
    }

    public render() {
        const { id, autoFocus, classes, placeHolder, label, inputRef, error, margin, onSelectedItemClick } = this.props;
        const { inputValue, selectedItems } = this.state;

        return (
            <div id={id} className={classes.root}>
                <div className={classes.container}>
                    <TextField
                        key={id}
                        fullWidth={true}
                        label={label}
                        error={error}
                        margin={margin}
                        InputProps={{
                            inputRef: inputRef,
                            classes: {
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            },
                            onChange: this.handleInputChange,
                            onKeyDown: this.handleKeyDown,
                            placeholder: placeHolder,
                            autoFocus: autoFocus,
                            value: inputValue,
                            startAdornment: selectedItems.map((item, index) => (
                                <Chip
                                    key={index}
                                    tabIndex={-1}
                                    label={item}
                                    size="small"
                                    onDelete={() => this.handleDelete(item)}
                                    onClick={() => onSelectedItemClick(item)}
                                />
                            ))
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default withStyles(InputAdormentStyles)(MuiTextInputToken);